import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function About() {
  return (
    <section id="id_about" className="tc-about">
      <div className="container">
        <div className="content pb-50 ps-40">
          <h2 className="about-title mb-150 js-splittext-lines">
            <div className="color-gray font-palast-regular">
              <span>
                Projetado para aqueles que valorizam a sabedoria como guia em
                suas escolhas, combinando{" "}
                <strong className="fsz-70 color-brown2 lh-1 font-palast-bold-italic">
                  espaços residenciais e corporativos
                </strong>{" "}
                que traduzem inovação e grandiosidade.
              </span>
            </div>
          </h2>
          <div className="main-content">
            <div className="row justify-content-between">
              <div
                className="col-12 col-lg-2 wow fadeInUp slow"
                data-wow-delay="0.2s"
              >
                <div className="text ltspc-2">
                  <p className="lh-2">propósito</p>
                  <p className="lh-2">inteligência</p>
                  <p className="lh-2">& excelência.</p>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="img wow zoomIn slow" data-wow-delay="0.2s">
                  <LazyLoadImage
                    src="/home_borin/assets/images/logo2.webp"
                    alt="imagem da fachada"
                    className="img-cover"
                    effect="blur"
                    width={"100%"}
                    height={"100%"}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-4 col-text">
                <h3 className="js-splittext-lines ltspc-0 lh-2 font-palast-regular">
                  <span className="about-subtitle font-palast-bold-italic fsz-33">
                    O mais sábio
                  </span>{" "}
                  <br />
                  <span className="color-gray fw-400">empreendimento</span>{" "}
                  <br />
                  <span className="color-gray fw-400">de Passo Fundo</span>
                </h3>
                <p
                  className="fsz-16 mt-40 js-splittext-lines color-gray ltspc-2"
                  data-wow-delay="0.2s"
                >
                  Reunindo vida comercial e residencial, o Wiser é{" "}
                  <strong className="fst-italic ltspc-0 font-palast-bold-italic fsz-21">
                    inspirado na sabedoria,
                  </strong>{" "}
                  onde cada espaço foi planejado e executado na{" "}
                  <strong className="fst-italic ltspc-0 font-palast-bold-italic fsz-21">
                    busca constante pela perfeição.
                  </strong>
                </p>
                <p
                  className="fsz-16 mt-20 js-splittext-lines color-gray ltspc-2"
                  data-wow-delay="0.2s"
                >
                  Sua localização privilegiada, modernidade e imponência são
                  dedicadas àqueles que sabem o que desejam. O perfeito está em{" "}
                  <strong className="fst-italic ltspc-0 font-palast-bold-italic fsz-21">
                    crer, fazer e administrar,
                  </strong>{" "}
                  mantendo a ética e a humildade de buscar a glória do saber
                  constante.
                </p>
                <p
                  className="fsz-16 mt-20 js-splittext-lines color-gray ltspc-2"
                  data-wow-delay="0.2s"
                >
                  Construa seu lar e negócio sobre as sólidas colunas do Wiser,
                  crescendo e realizando sonhos a cada dia, pois assim,{" "}
                  <strong className="fst-italic ltspc-0 font-palast-bold-italic fsz-21">
                    a vida se torna verdadeiramente interessante.
                  </strong>
                </p>

                <h4 className="fsz-24 mt-40 mb-10 js-splittext-lines color-gray2 font-palast-bold-italic">
                  Rachel Muterlle Borin
                </h4>
                <p className="fsz-14 js-splittext-lines fw-400 color-gray lh-2">
                  Sócia/Proprietária
                </p>
                <p className="fsz-14 js-splittext-lines fw-400 color-gray lh-2">
                  Borin Construções
                </p>
              </div>
            </div>
            <div className="row justify-content-between mt-60 the-origin">
              <div className="col-12 col-lg-5 origin">
                <h2 className="title-origin mt-100 js-splittext-lines color-brown2 text-uppercase font-palast-regular">
                  A origem
                </h2>
                <p
                  className="color-gray mt-50 js-splittext-lines ltspc-2 lh-2"
                  data-wow-delay="0.2s"
                >
                  <span className="fsz-16">
                    <strong className="fsz-20 lh-2 ltspc-1 font-palast-bold-italic">
                      O Wiser surgiu de uma visão:{" "}
                    </strong>
                    criar um espaço onde viver e trabalhar fossem experiências
                    conectadas através da sabedoria. Inspirado pela demanda de
                    profissionais que buscam consultórios modernos, com
                    atmosferas sofisticadas e espaços de bem-estar que traduzem
                    cuidado em experiência.
                  </span>
                </p>
                <p
                  className="fsz-16 color-gray mt-15 js-splittext-lines ltspc-2 lh-2"
                  data-wow-delay="0.2s"
                >
                  <span className="fsz-16">
                    Ao mesmo tempo, percebemos o desejo por apartamentos de alto
                    padrão em um lugar único, onde a exclusividade se alinha à
                    conveniência de uma localização impecável. Assim,
                    <strong className="fsz-20 lh-2 ltspc-1 font-palast-bold-italic">
                      {" "}
                      integramos a vida profissional e pessoal com perfeita
                      harmonia,
                    </strong>{" "}
                    oferecendo um estilo de vida que equilibra sofisticação e
                    praticidade.
                  </span>
                </p>
                <p
                  className="fsz-16 color-gray mt-15 js-splittext-lines ltspc-2 lh-2"
                  data-wow-delay="0.2s"
                >
                  <span className="fsz-16">
                    Mas o Wiser é mais do que uma escolha de moradia ou
                    trabalho.
                    <strong className="fsz-20 lh-2 ltspc-1 font-palast-bold-italic">
                      {" "}
                      É um marco arquitetônico,{" "}
                    </strong>
                    pensado para elevar a estética de Passo Fundo, agregando
                    valor ao cenário urbano. Cada linha e detalhe foram
                    desenhados para refletir um legado de bom gosto.
                  </span>
                </p>
              </div>
              <div className="col-12 col-lg-7">
                <div className="img wow zoomIn slow" data-wow-delay="0.2s">
                  <LazyLoadImage
                    src="/home_borin/assets/images/about.webp"
                    alt="imagem da fachada 2"
                    className="img-cover"
                    effect="blur"
                    width={"100%"}
                    height={"100%"}
                  />
                  <LazyLoadImage
                    src="/home_borin/assets/images/about2.svg"
                    alt="imagem da fachada 2"
                    className="img-cover img-effect"
                    effect="blur"
                    width={"50%"}
                    height={"70%"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
